import useInterval from './use-interval';

export { useInterval };

export default useInterval;
